import { delay, dispatcher, jurisdictionService, platform, soundService, StateController, ui, UI_EVENT } from "@aceroll/core";

class RoundCompletedController extends StateController {
    constructor() {
        super("round.completed");

        this.app = dispatcher.app;
    }

    async onStart() {
        // const hasMaxWin = serverData.nextResponses.length === 1 && (serverData.nextResponses[0].etn === 'max_win_reached');
        // if (hasMaxWin) {
        //     platform.setMaxWin();
        // }

        platform.onceRoundEnded().then(this.playFirmSound);

        await delay(150);

        platform.setGameRoundCompleted();

        this.app.layout.multiplierPanel.hide();

        // if (autoplay.isStarted()) {
        //     this.stop();
        // } else {
        ui.on(UI_EVENT.STATE_CHANGE, this.onUiStateChange, this);
        ui.on(UI_EVENT.AUTOPLAY_ROUND_STARTED, this.onAutoplayRoundStart, this);
        // }
    }

    async playFirmSound(roundData) {
        const { cheapSounds } = jurisdictionService;

        const betAmount = +roundData.betAmount;
        const win = +roundData.win;


        if (!win) {
            return;
        }

        const cheapWin = win < betAmount;

        if (cheapWin && cheapSounds) {
            return;
        }

        soundService.play('firm_sound');
    }

    onAutoplayRoundStart(roundsLeft) {
        this.stop();
    }

    async onUiStateChange(state) {
        if (state.current === 'idle') {
            this.stop();
        }
    }

    onStop() {
        ui.off(UI_EVENT.STATE_CHANGE, this.onUiStateChange, this);
        ui.off(UI_EVENT.AUTOPLAY_ROUND_STARTED, this.onAutoplayRoundStart, this);
    }
}

export default RoundCompletedController;